import Util from '../util';

const url = '/api/colorcalc/user_csv';
const Api = {
  /**
   * @param {object} params
   * @param {object} data
   */
  postAsync({ action, projectId: project_id, productId: product_id }, { file }) {
    const queryString = Util.queryString({action, project_id, product_id});
    const formData = new FormData();
    formData.append("source", file);
    return fetch(`${Util.apiSegment}${url}${queryString}`, {
      method: 'POST',
      body: formData
    }).then(response => response.json());
  }
};
export default Api;
